<lib-datepicker-dropdown
    class="filter"
    defaultTitle="Add {{ label }}"
    [(dateFrom)]="selectedDate.from"
    [(dateTo)]="selectedDate.to"
    (filterChanged)="onSelectedDateChange()"
    [dateRangeEnabled]="true"
    [rangeDirection]="rangeDirection ? rangeDirection : 'backward'"
    [allowSelectEmptyDate]="$safeNavigationMigration(additionalInfo?.allowSelectEmptyDate)"
    [emptyDateSelected]="selectedDate.includeEmpty"
    (emptyDateSelectedChange)="onCheckboxChange($event)"
>
</lib-datepicker-dropdown>
